import React from 'react'
import {  useEffect, useState } from "react";
import { getLatestNews } from './blog_data';


const LatestPosts = () => {

     const [latestPosts, setLatestPosts] = useState([]);
    
       useEffect(() => {
          
          async function fetchLatest() {
          
        
            const data = await getLatestNews();
            setLatestPosts(data);
          }
        
          fetchLatest();
        }, []);
  return (
    <div>


<h2 className="text-center display-5 fw-bold">Latest News</h2>

<div className="row row-cards row-deck row-cols-1 row-cols-md-4 g-4 mt-4 mx-auto mb-6">
  {latestPosts?.map((newsItem) => (
    
    <div key={newsItem?.id} className="col">
      <div className="card h-100  rounded-3 p-3 d-flex flex-column">
        
        <h3>{newsItem.title}</h3>
        <p className="flex-grow-1">
  {newsItem?.excerpt.length > 50 ? `${newsItem.excerpt.substring(0, 190)}...` : newsItem?.excerpt}
</p>

        <div className="mt-auto pt-3">
          <button
            onClick={() =>
              window.location.href =  `/news/${newsItem?.slug}`
            }
            className="btn btn-outline-primary w-100"
          >
            Read More
          </button>
        </div>

      </div>
    </div>
  ))}
</div>

    </div>
  )
}

export default LatestPosts